import Button from "../components/button/Button"
import WhoFits from "../components/whoFits/WhoFits"
import styles from "./ThirdScreen.module.css"

const ThirdScreen = () => {
    return (
        <div className={styles.background}>
            <h2 className={styles.mainTitle}>למה לבחור ללמוד דווקא אצלי?</h2>
            
            <div className={styles.introText}>
                <p>כי אני לא רק מלמדת - אני משקיעה את כל הלב שלי בתלמידות שלי.</p>
                <p>אני רואה כל אחת, מאמינה בכל אחת, ומובילה אותה יד ביד - עד שהיא מוכנה לצאת לדרך משלה, בביטחון, עם ידע, ועם תוצאות ברמה של חו"ל.</p>
                <p>אצלי אין חאפר. אין "בסדר". יש מצוינות, דיוק, שיטה מוכחת, ותשומת לב לפרטים הקטנים - כי שם נמצא ההבדל.</p>
            </div>

            <div className={styles.benefitsList}>
                <div className={styles.benefitItem}>
                    <span className={styles.checkmark}>✔️</span>
                    <span className={styles.benefitText}>שיטה ייחודית שפיתחתי בעצמי</span>
                </div>
                
                <div className={styles.benefitItem}>
                    <span className={styles.checkmark}>✔️</span>
                    <span className={styles.benefitText}>תוצאות אמיתיות כבר במהלך הקורס</span>
                </div>
                
                <div className={styles.benefitItem}>
                    <span className={styles.checkmark}>✔️</span>
                    <span className={styles.benefitText}>כיתות קטנות ליחס אישי</span>
                </div>
                
                <div className={styles.benefitItem}>
                    <span className={styles.checkmark}>✔️</span>
                    <span className={styles.benefitText}>ליווי גם אחרי הקורס - את לא לבד</span>
                </div>
                
                <div className={styles.benefitItem}>
                    <span className={styles.checkmark}>✔️</span>
                    <span className={styles.benefitText}> תעודה ובונוס מיוחד</span>
                </div>
                
                <div className={styles.benefitItem}>
                    <span className={styles.checkmark}>✔️</span>
                    <span className={styles.benefitText}>והכי חשוב - גישה בגובה העיניים, בלי פוזה ובלי אגו</span>
                </div>
            </div>
   <div className={styles.title}>אני מלמדת מהלב. כי זו לא רק קריירה - זו שליחות.</div>
            <div className={styles.closingText}>
             
                <p>ואם את רוצה ללמוד באמת ולהפוך את הכישרון שלך למקצוע מכניס - אני כאן בשבילך 💅</p>
            </div>

            <Button text="תלחצי כאן ואנחנו מדברות!"/>

            <div className={styles.title}>אז למי מתאים להכנס לתחום הציפורניים..?</div>
            <WhoFits/>
            <Button text="אסתר, אני מתאימה!"/>
        </div>
    )
}

export default ThirdScreen